import { Box, Button } from '@mui/material';
import { t } from 'i18next';

const TaskListActionBar = ({
  collapseAllCategories,
  allCategoriesAreUncollapsed
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      marginTop={1.5}
      marginBottom={1.75}
    >
      <Button
        onClick={collapseAllCategories}
        sx={{
          padding: 0,
          margin: 0,
          minWidth: 'inherit',
          minHeight: 'inherit',
          textTransform: 'none',
          fontSize: '14px',
          fontFamily: 'signikalight!important'
        }}
      >
        {t(
          `taskList.${
            allCategoriesAreUncollapsed ? 'collapseAll' : 'uncollapseAll'
          }`
        )}
      </Button>

      {/* 
      // TODO - Enable when filter functionality is ready
      <ListItemIcon sx={{ display: 'contents' }}>
        <FontAwesomeSvgIcon icon={faSliders} fontSize="small" />
      </ListItemIcon> */}
    </Box>
  );
};

export default TaskListActionBar;
